module.exports = __webpack_public_path__ + "be2d99d1af18cb0292565bd11f6123b4.svg";